import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { useCallerInfo } from '../../hooks/use-caller-info';
import { CALL_BAR_HEIGHT } from '../call-bar/constants';
import { IncomingCallBarContent } from './incoming-cb-content';
import { IncomingCallBarHead } from './incoming-cb-head';
import { useShowIncomingCallBar } from './incoming-cb-hook';
import { IncomingCallBarTrail } from './incoming-cb-trail';

export const IncomingCallBar = ({
  onHandleTrailIcon,
  showTrailingIcon,
  numOfIncomingCalls,
  className,
  callData,
  onEndCall,
  onAnswerCall,
}: {
  onHandleTrailIcon: () => void;
  showTrailingIcon: boolean;
  numOfIncomingCalls: number;
  className?: string;
  onEndCall: () => void;
  onAnswerCall: () => void;
  callData: ReturnType<typeof useShowIncomingCallBar> &
    ReturnType<typeof useCallerInfo> & {
      image?: string;
    };
}) => {
  const { latestIncomingCall, image, title, contact, setPosition, count, disabledLeftArrow, disabledRightArrow } =
    callData;

  const { FirstName = '', LastName = '' } = contact ?? {};
  const name = (FirstName + ' ' + LastName).trim();

  return (
    <section css={callBarContainer} className={className}>
      <div css={{ gridArea: 'lead' }} className='lead'>
        <IncomingCallBarHead image={image} title={title} name={name} />
      </div>
      <div css={{ gridArea: 'content' }} className='content'>
        <IncomingCallBarContent onEndCall={onEndCall} onAnswerCall={onAnswerCall} incomingCall={latestIncomingCall} />
      </div>
      <IncomingCallBarTrail
        numOfIncomingCalls={numOfIncomingCalls}
        disabledLeftArrow={disabledLeftArrow}
        disabledRightArrow={disabledRightArrow}
        count={count}
        setPosition={setPosition}
        showTrailingIcon={showTrailingIcon}
        onHandleTrailIcon={onHandleTrailIcon}
      />
    </section>
  );
};

export const callBarContainer = css`
  min-width: 344px;
  max-width: 344px;
  background-color: ${theme.colors.neutral90};
  border-radius: ${theme.borderRadius.medium};
  width: 100%;
  display: grid;
  height: ${CALL_BAR_HEIGHT}px;
  grid-template-areas: 'lead content trail';
  grid-template-columns: auto 1fr auto;
  align-items: center;
  cursor: pointer;
  padding: ${theme.spacing(1, 2)};
  z-index: ${theme.zIndex.modal};
  -webkit-tap-highlight-color: transparent;
  -moz-tap-highlight-color: transparent;
  -o-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
  box-shadow: 0 0 8px 4px rgba(8, 135, 63, 0.5);

  .lead,
  .trail {
    display: flex;
    align-items: center;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    gap: ${theme.spacing(0.5)};
    min-width: 0;
  }
  .content {
    display: flex;
    justify-content: end;
    align-items: center;
    flex: 1;
    gap: ${theme.spacing(1)};
    padding-left: ${theme.spacing(1)};
  }

  &:has(.trail) .content {
    padding-right: ${theme.spacing(1)};
  }
`;
